import React from "react";
import PropTypes from "prop-types";
import HistoryIcon from "@material-ui/icons/History";
import clsx from "clsx";
import { getFormattedDate } from "../../../../../Utils/Helpers/dateUtils";
import useStyles from "./ProfessionalContacts.styles";

const DeletedContactsHistory = ({ deletedContacts }) => {
  const classes = useStyles();
  if (!deletedContacts || deletedContacts.length === 0) return null;

  return (
    <>
      <div className={classes.sectionHeading}>
        <HistoryIcon fontSize="inherit" /> Deleted individuals (
        {deletedContacts.length})
      </div>
      {deletedContacts.map((contact, index) => (
        <div
          key={`${contact.name}-${index}`}
          className={clsx(classes.rowItem, classes.rowItemDeleted)}
        >
          <div className={classes.rowGrow}>
            <span className={classes.strikethrough}>
              {contact.name || "(unnamed)"}
            </span>{" "}
            {contact.role ? `· ${contact.role}` : "-"}
            <div className={classes.subtle}>
              {contact.email} · {contact.phone}
            </div>
          </div>
          <span className={classes.rowMeta}>
            Removed {getFormattedDate(contact.deletedUtc, "DD/MM/YYYY, HH:mm") || "-"}
            {getFormattedDate(contact.deletedUtc, "DD/MM/YYYY, HH:mm") || "-"}
            {contact.deletedBy ? (
              <>
                <br />
                by {contact.deletedBy}
              </>
            ) : null}
          </span>
        </div>
      ))}
      <div className={classes.hint}>Retained for audit. Deleted individuals are no longer selectable on loans.</div>
    </>
  );
};

DeletedContactsHistory.propTypes = {
  deletedContacts: PropTypes.array,
};

export default DeletedContactsHistory;
